
import Vue from 'vue';
import axios from 'axios';
import * as Helpers from '../services/helpers';
import * as Ws from '../services/ws';
import InitialStep from './InitialStep.vue';
import { prepare_for_compare } from '../../../shared/validators/displayName';
import { at } from 'lodash';

export default Vue.extend({
  name: 'ModerateList',
  components: { InitialStep },
  data: () => ({
    svs: null,
    initialSteps: undefined,
    filter: undefined,
  }),
  mounted() {
      this.listRec({});
      Ws.loggedUserInitialSteps().then(val => this.initialSteps = val);
  },
  beforeDestroy() {
    if (this.cancelP) this.cancelP.cancel("");
  },
  computed: { 
      svsGroupedByStep() {
         let svs = this.svs as ClientSideSVA[]
         if (this.filter) {
            const wanted_words = prepare_for_compare(this.filter).split(/\s+/)
            for (const sv of svs) {
                sv.v.for_compare ||= prepare_for_compare(at(sv.v, 'sn', 'givenName').join("  "))
            }
            svs = svs.filter(sv => wanted_words.every(word => sv.v.for_compare.includes(word)))
         }
         return this.svs ? Helpers.groupBy(svs, sv => sv.stepName) : undefined;
      },
  },
  methods: {
    listRec(params) {
        this.cancelP = axios.CancelToken.source();

        Ws.listInScope(this, params, this.cancelP.token).then(rc => {
            if (rc !== "cancel") {
                this.listRec({ poll: true });
            }
        });
    },
  },
});
